import DayDetailsCellRenderer from "./DayDetailsCellRenderer";

export default class OtherTasksCellRenderer extends DayDetailsCellRenderer {
    constructor(cssBaseClass, cssTopBorderClass) {
        super(cssBaseClass, cssTopBorderClass);
    }

    addTooltip(cell) {

    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/OtherTasksCellRenderer.js